import React from "react";

//import Scss
import "./assets/scss/themes.scss";

import Maintenance from "./pages/Maintenance";

function App() {
  return <Maintenance />;
}

export default App;
